export interface AfterInit {
  $afterInit(): void | Promise<any>;
}
